module.exports = __webpack_public_path__ + "static/home_header_1-de79f4999a745691480576fe91c00c3b.png";